export const maquinModel = {
  pv: null,
  ns: null,
  np: null,
  ne: null,
  st: false,
};
